import { render, staticRenderFns } from "./PreVideo.vue?vue&type=template&id=0e805ea5&scoped=true&"
import script from "./PreVideo.vue?vue&type=script&lang=js&"
export * from "./PreVideo.vue?vue&type=script&lang=js&"
import style0 from "./PreVideo.vue?vue&type=style&index=0&id=0e805ea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e805ea5",
  null
  
)

export default component.exports